import { computed, ComputedRef, ref, Ref } from "vue";
import { useStore } from "vuex";

export const key = Symbol("editFlipbookTocButton");

export interface EditFlipbookTocButtonApi {
  show: ComputedRef<boolean>;
  setIsEditing: (val: boolean) => void;
  isEditing: Ref<boolean>;
}

const isEditing = ref(false);

export default function createData(): EditFlipbookTocButtonApi {
  const store = useStore();
  return {
    show: computed(() => store.getters.showCMS),
    setIsEditing(val) {
      isEditing.value = val;
    },
    isEditing,
  };
}

const injectError = `Inject has failed for EditFlipbookTocButtonApi`;

export const defaultApi: EditFlipbookTocButtonApi = {
  show: computed(() => false),
  setIsEditing: () => console.error(injectError),
  isEditing: ref(false),
};

export const storybookApi: EditFlipbookTocButtonApi = {
  show: computed(() => false),
  setIsEditing: () => alert("Editing table of contents for yearbook"),
  isEditing: ref(false),
};
